module.exports = __webpack_public_path__ + "img/Unidad8-5.81aee728.png";